var map = {
	"./collection-back.png": 1536,
	"./collection-background.jpg": 1537,
	"./collection-bird-01-effect.png": 1538,
	"./collection-bird-01.png": 1539,
	"./collection-bird-02-effect.png": 1540,
	"./collection-bird-02.png": 1541,
	"./collection-bird-03-effect.png": 1542,
	"./collection-bird-03.png": 1543,
	"./collection-bird-04-effect.png": 1544,
	"./collection-bird-04.png": 1545,
	"./collection-bird-05-effect.png": 1546,
	"./collection-bird-05.png": 1547,
	"./collection-bird-06-effect.png": 1548,
	"./collection-bird-06.png": 1549,
	"./collection-bird-07-effect.png": 1550,
	"./collection-bird-07.png": 1551,
	"./collection-bird-08-effect.png": 1552,
	"./collection-bird-08.png": 1553,
	"./collection-bird-09-effect.png": 1554,
	"./collection-bird-09.png": 1555,
	"./collection-bird-10-effect.png": 1556,
	"./collection-bird-10.png": 1557,
	"./collection-bird-11-effect.png": 1558,
	"./collection-bird-11.png": 1559,
	"./collection-bird-12-effect.png": 1560,
	"./collection-bird-12.png": 1561,
	"./collection-feather-getting.png": 1562,
	"./collection-feather.png": 1563,
	"./collection-hatching.png": 1564,
	"./main-background.jpg": 1565,
	"./main-bg-number.png": 1566,
	"./main-bird-0.png": 1567,
	"./main-bird-1.png": 1568,
	"./main-bird-normal.png": 1569,
	"./main-bird-rest-dialog.png": 1570,
	"./main-bird.png": 1571,
	"./main-egg.png": 1572,
	"./main-energy-bar.png": 1573,
	"./main-energy.png": 1574,
	"./main-goto-play.png": 1575,
	"./main-green-0.png": 1576,
	"./main-green-1.png": 1577,
	"./main-green-2.png": 1578,
	"./main-green-3.png": 1579,
	"./main-green-4.png": 1580,
	"./main-green-5.png": 1581,
	"./main-green-6.png": 1582,
	"./main-green-7.png": 1583,
	"./main-green-8.png": 1584,
	"./main-green-9.png": 1585,
	"./main-hatching-failed.png": 1586,
	"./main-hatching-success.png": 1587,
	"./main-hatching-waiting.png": 1588,
	"./main-home.png": 1589,
	"./main-red-0.png": 1590,
	"./main-red-1.png": 1591,
	"./main-red-2.png": 1592,
	"./main-red-3.png": 1593,
	"./main-red-4.png": 1594,
	"./main-red-5.png": 1595,
	"./main-red-6.png": 1596,
	"./main-red-7.png": 1597,
	"./main-red-8.png": 1598,
	"./main-red-9.png": 1599,
	"./main-stage-1.png": 1600,
	"./main-stage-2-locked.png": 1601,
	"./main-stage-2.png": 1602,
	"./main-stage-3-locked.png": 1603,
	"./main-stage-3.png": 1604,
	"./main-stage-4-locked.png": 1605,
	"./main-stage-4.png": 1606,
	"./main-stage-5-locked.png": 1607,
	"./main-stage-5.png": 1608,
	"./main-unlocking.png": 1609,
	"./play-background-1.jpg": 1610,
	"./play-background-2.jpg": 1611,
	"./play-background-3.jpg": 1612,
	"./play-background-4.jpg": 1613,
	"./play-background-5.jpg": 1614,
	"./play-board-1.png": 1615,
	"./play-board-2.png": 1616,
	"./play-board-3.png": 1617,
	"./play-board-4.png": 1618,
	"./play-board-5.png": 1619,
	"./play-board-intro-1.png": 1620,
	"./play-board-intro-2.png": 1621,
	"./play-board-intro-3.png": 1622,
	"./play-board-intro-4.png": 1623,
	"./play-board-intro-5.png": 1624,
	"./play-boss-1.png": 1625,
	"./play-boss-2.png": 1626,
	"./play-boss-3.png": 1627,
	"./play-boss-4.png": 1628,
	"./play-boss-5.png": 1629,
	"./play-boss-capture.png": 1630,
	"./play-boss-egg-broken.png": 1631,
	"./play-boss-lose-1.png": 1632,
	"./play-boss-lose-2.png": 1633,
	"./play-boss-lose-3.png": 1634,
	"./play-boss-lose-4.png": 1635,
	"./play-boss-lose-5.png": 1636,
	"./play-boss-pass.png": 1637,
	"./play-boss-shooting-failed.png": 1638,
	"./play-boss-shooting.png": 1639,
	"./play-boss-territory.png": 1640,
	"./play-captured-stone.png": 1641,
	"./play-egg-boss-0.png": 1642,
	"./play-egg-boss-1.png": 1643,
	"./play-egg-boss-2.png": 1644,
	"./play-egg-boss-3.png": 1645,
	"./play-egg-boss-4.png": 1646,
	"./play-egg-boss-5.png": 1647,
	"./play-egg-boss-6.png": 1648,
	"./play-egg-boss-7.png": 1649,
	"./play-egg-boss-8.png": 1650,
	"./play-egg-boss-9.png": 1651,
	"./play-egg-boss.png": 1652,
	"./play-egg-player-0.png": 1653,
	"./play-egg-player-1.png": 1654,
	"./play-egg-player-2.png": 1655,
	"./play-egg-player-3.png": 1656,
	"./play-egg-player-4.png": 1657,
	"./play-egg-player-5.png": 1658,
	"./play-egg-player-6.png": 1659,
	"./play-egg-player-7.png": 1660,
	"./play-egg-player-8.png": 1661,
	"./play-egg-player-9.png": 1662,
	"./play-egg-player.png": 1663,
	"./play-endgame.png": 1664,
	"./play-excellent.png": 1665,
	"./play-fantastic.png": 1666,
	"./play-lamp-left.png": 1667,
	"./play-lamp-right.png": 1668,
	"./play-left-gun.png": 1669,
	"./play-player-capture.png": 1670,
	"./play-player-egg-broken.png": 1671,
	"./play-player-intro.png": 1672,
	"./play-player-lose.png": 1673,
	"./play-player-pass.png": 1674,
	"./play-player-shooting-failed.png": 1675,
	"./play-player-shooting.png": 1676,
	"./play-player-territory.png": 1677,
	"./play-player.png": 1678,
	"./play-resign.png": 1679,
	"./play-right-gun.png": 1680,
	"./play-run.png": 1681,
	"./play-runaway.png": 1682,
	"./play-score-1.png": 1683,
	"./play-score-2.png": 1684,
	"./play-score-3.png": 1685,
	"./play-score-4.png": 1686,
	"./play-score-5.png": 1687,
	"./play-soul-0.png": 1688,
	"./play-soul-1.png": 1689,
	"./play-soul-2.png": 1690,
	"./play-soul-3.png": 1691,
	"./play-soul-4.png": 1692,
	"./play-soul-5.png": 1693,
	"./play-soul-6.png": 1694,
	"./play-soul-7.png": 1695,
	"./play-soul-8.png": 1696,
	"./play-soul-9.png": 1697,
	"./play-soul.png": 1698,
	"./play-stone-boss-1-active.png": 1699,
	"./play-stone-boss-1.png": 1700,
	"./play-stone-boss-2-active.png": 1701,
	"./play-stone-boss-2.png": 1702,
	"./play-stone-boss-3-active.png": 1703,
	"./play-stone-boss-3.png": 1704,
	"./play-stone-boss-4-active.png": 1705,
	"./play-stone-boss-4.png": 1706,
	"./play-stone-boss-5-active.png": 1707,
	"./play-stone-boss-5.png": 1708,
	"./play-stone-boss-fixed.png": 1709,
	"./play-stone-player-active.png": 1710,
	"./play-stone-player-fixed.png": 1711,
	"./play-stone-player.png": 1712,
	"./play-triple.png": 1713,
	"./play-undo.png": 1714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1535;